$(document).ready(function () {
  $('.contact--question--li').click(function () {
    var tab_id = $(this).attr('data-tab');

    $('.contact--question--li').removeClass('is-open');
    $('.contact__answer-inside').removeClass('is-open');

    $(this).addClass('is-open');
    $('#' + tab_id).addClass('is-open');
  });

  var path = window.location.href;

  if (path.indexOf('#eagle') >= 0) {
    var maxItems = $('.contact--question--li').length;
    $('.contact--question--li[data-tab="' + maxItems + '"]').addClass(
      'is-open'
    );
    $('#' + maxItems).addClass('is-open');
  } else if (path.indexOf('kontakt') >= 0 || path.indexOf('contact') >= 0) {
    $('.contact--question--li[data-tab="4"]').addClass('is-open');
    $('#4').addClass('is-open');
  }
});
